/**
 * @file modules/my_cash_load_more.js
 * @description Vanilla JS module for "Load more" pagination on the My Cash page.
 *              Intercepts clicks on load-more links, fetches HTML partial via fetch(),
 *              and appends new rows to the table.
 */

import { dispatchTrack } from "../analytics/shop-analytics-track.js";

export function initLoadMore() {
  const history = document.querySelector(".my-cash-history");
  if (!history) return;

  history.addEventListener("click", async (event) => {
    const link = event.target.closest(".my-cash-load-more-btn");
    if (!link) return;

    event.preventDefault();

    const href = link.getAttribute("href");
    if (!href) return;

    const activeView = history.querySelector(
      ".my-cash-history-container--active",
    )?.dataset.view;
    dispatchTrack(link, "my_cash_load_more_click", {
      source: "My Cash",
      view: activeView || "unknown",
    });

    link.textContent = "Loading...";
    link.classList.add("my-cash-load-more-btn--loading");

    try {
      const response = await fetch(href, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "text/html",
        },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const responseEl = doc.querySelector(".my-cash-load-more-response");
      if (!responseEl) throw new Error("Invalid response format");

      // Find the active history container
      const activeContainer = history.querySelector(
        ".my-cash-history-container--active",
      );
      if (!activeContainer) return;

      // Append desktop rows from <template>
      const desktopTemplate = responseEl.querySelector(
        ".my-cash-load-more-response__desktop",
      );
      if (desktopTemplate) {
        const tbody = activeContainer.querySelector(
          ".my-cash-history-table tbody",
        );
        if (tbody) {
          tbody.insertAdjacentHTML("beforeend", desktopTemplate.innerHTML);
        }
      }

      // Append mobile items from <template>
      const mobileTemplate = responseEl.querySelector(
        ".my-cash-load-more-response__mobile",
      );
      if (mobileTemplate) {
        const mobileContainer = activeContainer.querySelector(
          ".my-cash-history-mobile",
        );
        if (mobileContainer) {
          mobileContainer.insertAdjacentHTML(
            "beforeend",
            mobileTemplate.innerHTML,
          );
        }
      }

      // Replace pagination button
      const paginationEl = responseEl.querySelector(
        ".my-cash-load-more-response__pagination",
      );
      const viewMoreContainer = link.closest(".my-cash-view-more");
      if (viewMoreContainer && paginationEl) {
        // Move the already-parsed nodes directly instead of round-tripping
        // through an HTML string.
        viewMoreContainer.replaceChildren(...paginationEl.childNodes);
      }
    } catch {
      link.textContent = "Load more";
      link.classList.remove("my-cash-load-more-btn--loading");
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLoadMore);
} else {
  initLoadMore();
}
